<template>
    <v-dialog v-model="dialog" :transition="false" persistent scrollable width="2000">
        <template v-slot:activator="{ on: btn, attrs }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="{ ...tooltip, ...btn }"
                    >
                        <v-icon>mdi-currency-eur</v-icon>
                    </v-btn>

                </template>
                <span>Pakket prijs zoeken</span>
            </v-tooltip>
        </template>
        <v-card>
            <v-toolbar flat dark color="primary">
                <v-toolbar-title>Pakket prijs zoeken</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pt-4">
                <Search />
            </v-card-text>
            <v-card-actions>
                <v-btn color="secondary" @click="dialog=false" outlined>
                    <v-icon left>mdi-close</v-icon>
                    Sluiten
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Search from "@/components/Package/SearchPrice/Search.vue";
export default {
    components: {
        Search
    },
    data() {
        return {
            dialog: false,
        }
    },
}
</script>
